import { DestroyRef, Injectable, inject, signal } from '@angular/core';
import { IplpRecipeDetailObject, IplpRecipeObject } from '@libs/types/src/list/object-type/iplp-recipe.object';
import {
    ComponentStoreV2Factory,
} from '../../../../../modules/shared/store/common/component-store-v2.factory';
import { iplpRecipeDetailFrag, iplpRecipesFrag } from './folder-e-prescription-magistraliter-recipes-dialog.query';

@Injectable()
export class FolderEPrescriptionMagistraliterRecipesDialogStore extends ComponentStoreV2Factory {
    private readonly destroyRef = inject(DestroyRef);

    public readonly recipes = signal<IplpRecipeObject[]>([]);
    public readonly loading = this.loadingFor('getIplpRecipes');
    public readonly unavailable = signal(false);
    public readonly detail = signal<IplpRecipeDetailObject | null>(null);
    public readonly detailLoading = this.loadingFor('getIplpRecipeDetail');
    public readonly detailUnavailable = signal(false);

    private detailRequest = 0;

    public async load(): Promise<void> {
        if (this.loading()) return;
        this.unavailable.set(false);
        try {
            const recipes = await this.api.getIplpRecipes(iplpRecipesFrag);
            if (!recipes) throw new Error('Missing recipe list');
            if (!this.destroyRef.destroyed) this.recipes.set(recipes);
        } catch {
            if (!this.destroyRef.destroyed) this.unavailable.set(true);
        }
    }

    public async loadDetail(slug: string): Promise<IplpRecipeDetailObject | null> {
        if (this.detail()?.slug === slug) return this.detail();
        const request = ++this.detailRequest;
        this.detail.set(null);
        this.detailUnavailable.set(false);
        try {
            const detail = await this.api.getIplpRecipeDetail(slug, iplpRecipeDetailFrag);
            if (!detail || detail.slug !== slug) throw new Error('Missing recipe detail');
            if (this.destroyRef.destroyed || request !== this.detailRequest) return null;
            this.detail.set(detail);
            return detail;
        } catch {
            if (!this.destroyRef.destroyed && request === this.detailRequest) this.detailUnavailable.set(true);
            return null;
        }
    }
}
